import React from 'react';

const iconeAppGenerico = process.env.PUBLIC_URL + '/app/icone-app-generico.png';

const niveis = [
  {
    numero: '1',
    titulo: 'Comece agora',
    itens: ['Plataforma completa', 'Aplicativo genérico', 'Subdomínio gratuito', 'Operação imediata'],
    exemplo: 'suaempresa.nvmonitor.com.br',
    destaque: false,
  },
  {
    numero: '2',
    titulo: 'Domínio próprio',
    itens: ['Plataforma completa', 'Domínio próprio configurado', 'SSL incluído', 'URL 100% personalizada', 'White label avançado'],
    exemplo: 'suaempresa.com.br',
    destaque: false,
    nota: true,
  },
  {
    numero: '3',
    titulo: 'White label completo',
    itens: ['Plataforma completa', 'Domínio próprio', 'Aplicativo personalizado', 'Logo própria nas lojas', 'Publicação Android e iOS', 'Experiência 100% da sua marca'],
    exemplo: 'App "Sua Empresa" — Play Store e App Store',
    destaque: true,
    nota: true,
  },
];

export default function NiveisWhiteLabel() {
  return (
    <section id="white-label">
      <div className="container">
        <div className="section-head">
          <div className="eyebrow" style={{ justifyContent: 'center' }}>Cresça no seu ritmo</div>
          <h2>Comece simples. Evolua pra um White Label completo quando quiser.</h2>
          <p>A Nivocar oferece diferentes níveis de personalização — você escolhe o ponto de partida ideal pra sua empresa hoje, e avança pros próximos níveis conforme cresce.</p>
        </div>

        {/* App genérico vs personalizado */}
        <div className="app-compare">
          <div className="app-compare-text">
            <div className="eyebrow">O aplicativo</div>
            <h3>Duas formas de colocar sua operação na mão do cliente</h3>
            <div className="app-compare-item">
              <strong>Aplicativo genérico — comece agora</strong>
              <p>Usamos um aplicativo próprio, com identidade visual neutra — sem a marca Nivocar em lugar nenhum. O cliente final não identifica nenhuma marca concorrente, e você já sai operando na hora.</p>
            </div>
            <div className="app-compare-item">
              <strong>Aplicativo personalizado — sua marca nas lojas</strong>
              <p>No nível máximo, você publica o próprio aplicativo: nome da empresa, ícone, logo, splash screen e cores próprias — disponível na Play Store e na App Store com a marca da sua empresa.</p>
            </div>
          </div>
          <div className="app-icon-showcase">
            <div className="app-icon-frame">
              <img src={iconeAppGenerico} alt="Ícone do aplicativo genérico Nivocar" />
            </div>
            <span className="app-icon-caption">Identidade visual neutra — pronto pra uso imediato</span>
          </div>
        </div>

        {/* 3 níveis */}
        <div className="niveis-grid">
          {niveis.map((n) => (
            <div className={`nivel-card${n.destaque ? ' destaque' : ''}`} key={n.numero}>
              {n.destaque && <span className="nivel-badge">Máximo white label</span>}
              <span className="nivel-numero">Nível {n.numero}</span>
              <h3>{n.titulo}</h3>
              <ul className="nivel-lista">
                {n.itens.map((item, i) => (
                  <li key={i}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                    {item}
                  </li>
                ))}
              </ul>
              <div className="nivel-exemplo mono">{n.exemplo}</div>
            </div>
          ))}
        </div>
        <p className="niveis-nota">* Domínio próprio (níveis 2 e 3) tem uma taxa única de configuração — inclui apontamento DNS, SSL e integração completa.</p>
      </div>
    </section>
  );
}
